import Vue from "vue";
import lodash from "lodash";

/* eslint-disable */
class AppFormErrors {
  constructor() {
    this.errors = {};
  }

  all() {
    return this.errors;
  }

  add(field, error) {
    this.errors[field] = [error ];
  }

  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0];
    }
    return false;
  }

  has(field) {
    return Object.prototype.hasOwnProperty.call(this.errors, field);
  }

  any() {
    return Object.keys(this.errors).length > 0;
  }

  record(errors) {
    this.errors = errors;
  }

  clear(field) {
    if (typeof field === 'undefined') {
      this.errors = {};
    } else if (Array.isArray(field)) {
      field.forEach(errorField => {
        const backup = window.clone(this.errors);
        delete backup[errorField.replace(/-/g, '.')];

        this.errors = backup;
      });
    } else {
      const backup = window.clone(this.errors);
      delete backup[field.replace(/-/g, '.')];

      this.errors = backup;
    }
  }

  compact(exclude) {
    if (!this.errors) {
      return {};
    }

    const results = {};
    const added = [];

    let toExclude;
    if (typeof exclude === 'string') {
      toExclude = exclude;
    } else {
      toExclude = false;
    }

    lodash.forEach(this.errors, (error, key) => {
      const section = lodash.get(key.split('.'), '[0]');

      if (!added.includes(section) && toExclude !== section) {
        added.push(section);

        results[section] = [lodash.startCase(lodash.toLower(section))];
      }
    });

    return results;
  }

  sections() {
    const compactedErorrs = this.compact();

    return Object.keys(compactedErorrs) || [];
  }
}

class AppForm {
  constructor(data) {
    this._fields = [];
    this.originalData = lodash.clone(data);

    // Initialise the fields of this form.
    for (let field in data) {
      if (data.hasOwnProperty(field)) {
        this._fields.push(field);
      }
    }

    // Load data from supplied constructor data
    this.loadData(data);

    this.errors = new AppFormErrors();
    this.busy = false;
  }

  loadData(data) {
    if (!data) {
      data = {};
    }

    for (let i in this._fields) {
      // noinspection JSUnfilteredForInLoop
      const field = this._fields[i];

      if (data.hasOwnProperty(field)) {
        this[field] = data[field];
      }
    }
  }

  getFields() {
    return this._fields;
  }

  startProcessing() {
    this.errors.clear();
    this.busy = true;
  }

  finishProcessing() {
    this.busy = false;
  }

  data() {
    let data = {};

    for (let field in this.originalData) {
      if (this.originalData.hasOwnProperty(field)) {
        data[field] = this[field];
      }
    }

    return data;
  }

  reset() {
    for (let field in this.originalData) {
      if (this.originalData.hasOwnProperty(field)) {
        this[field] = this.originalData[field];
      }
    }

    this.errors.clear();
    this.busy = false;
  }

  nullify(prop) {
    this[prop] = null;
  }

  post(url) {
    return this.submit('post', url);
  }

  put(url) {
    return this.submit('put', url);
  }

  destroy(url) {
    return this.submit('delete', url);
  }

  upload(url) {
    const form = this;

    return new Promise((resolve, reject) => {
      form.startProcessing();

      const formData = new FormData();
      for (let field in this.originalData) {
        if (this.originalData.hasOwnProperty(field)) {
          formData.append(field, form[field]);
        }
      }

      Vue.http.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.onSuccess(response.body);

          form.finishProcessing();
          resolve(response.data);
        })
        .catch(response => {
          this.onError(response.body.errors);

          form.finishProcessing();
          reject(response.data);
        });
    });
  }

  notReady() {
    return this.busy || this.errors.any();
  }

  submit(method, uri) {
    const form = this;

    return new Promise((resolve, reject) => {
      form.startProcessing();

      Vue.http[method](uri, this.data())
        .then(response => {
          this.onSuccess(response.body);

          form.finishProcessing();
          resolve(response.data);
        })
        .catch(response => {
          this.onError(response.body.errors);

          form.finishProcessing();
          reject(response.data);
        });
    });
  }

  onSuccess() {
    this.errors.clear();
    this.busy = false;
  }

  onError(errors) {
    this.errors.record(errors);
  }
}

export default AppForm;
